<template>
    <div class="box">
        <div class="form">
            <van-field class="title" :label="detail.detail.deliveryObjectName" readonly />
            <van-field label="收货人" :value="detail.detail.deliveryContact" readonly />
            <!-- <van-field label="联系方式" :value="detail.detail.deliveryContactTel | hidePhone" readonly /> -->
               <div class="my-field">
                <div class="label">联系方式</div>
                <div class="content">
                    <span>{{ detail.detail.deliveryContactTel }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', detail.detail.deliveryContactTel, 6)" href="javascript:void(0)" />
                </div>
            </div>
            <van-field
                readonly
                rows="2"
                autosize
                label="详细地址"
                type="textarea"
                show-word-limit
                :value="detail.detail.deliveryRefundAddress"
            />
        </div>
        <div class="form" v-if="detail.detail.visitorContactTel">
            <van-field class="title" label="游客地址" readonly />
            <van-field label="收货人" :value="detail.detail.visitorContact" readonly />
            <!-- <van-field label="联系方式" :value="detail.detail.visitorContactTel | hidePhone" readonly /> -->
             <div class="my-field">
                <div class="label">联系方式</div>
                <div class="content">
                    <span>{{ detail.detail.visitorContactTel }}</span>
                    <a class="call-icon" @click="util.callConfirm('拨打该号码？', detail.detail.visitorContactTel, 1)" href="javascript:void(0)" />
                </div>
            </div>
            <van-field
                readonly
                rows="2"
                autosize
                label="详细地址"
                type="textarea"
                show-word-limit
                :value="detail.detail.visitorAddress"
            />
        </div>
    </div>
</template>

<script>
    import util from '../../../../utils/common'

    export default {
        data () {
            return {
                detail: {}
            }
        },
        created () {
            this.detail = this.$store.state.refund.detail
            console.log(this.detail, '退货单详情')
            this.setDetail()
        },
        methods: {
            setDetail () {
                if (this.detail && this.detail.history) {
                    this.disposalDetails = this.detail.history.find(i => i.optText === '已反馈寄件地址')
                    this.disposalDetails.time = util.getStampInDate(this.disposalDetails.creatTime, '/')
                    this.detail.detail.deliveryObjectName = this.detail.detail.deliveryObject == 10 ? '监理中心地址' : '销售企业地址'
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .box {
        padding: 16px 16px 0;
        background-color: #f8f9fc;
        min-height: 100vh;
        /deep/.form {
            margin-bottom: 16px;
            border-radius: 4px;
            background: white;

             .van-field__label {
                width: 56px;
                margin-right: 16px;
            }


            .my-field {
                background-color: white;
                display: flex;
                align-items: center;
                padding: 10px 0;
                margin: 0 16px;
                border-bottom: 0.1px solid #ebedf0;
                .label {
                    color: #646566;
                    font-size: 14px;
                    width: 56px;
                    margin-right: 16px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #323233;
                      .call-icon {
                            display: inline-block;
                            width: 25px;
                            height: 25px;
                            background-color: #e9f7f1;
                            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA/5JREFUSEutll1sFFUUx/9nZit1d4mRvkHACC8akyZCaJESbBPRsFttDLaJJoKBSHgCgtuWaAhXfah2iyViIEaM3zHY+KC7tUCElqiBjhATwkcIRh/kgYQQa7Lb2u7OHL0z95a7012BXc/DZu8kc37zP5+XUMmEsLBXMAgM+StN/q/RAkdhkwACNx5LxeqL1sPRaPTCWJv42wfXCJ0LlMqE8FqO9ywszvDnzNxGFh3J5WMbL3aJmVqhpUCloOXb3iVFcjMMNAIoAoiA+IDTvm/7/wdUsBWZrVGb7suCuU3BbAAeABsR6nLWp4c6v+q0h7qG3GrSeUuhCmVzNrWTGYMACgDqlFMJtABccRFffu5pMVmt0gCo1LWOivqpfP4SMz/oP5V1ecuCs0UvOMn0l9WqDBxqdSO9a7jonlJqwhGTIbRhWe84yf5XWkdFZKxNyPzelflA/bWrhnu2eZ53qIK6II82bXIS6U9rUqi/tmk4tRcehCoSmTNtOoefJc7FXxJCyHNV5ivUwJXZ1B5ivBEC+rkjwsF7Y/EdfhhrGAAlIW3Odm9m5g+NkAaFQnTDXlB84PTqwalaYMF0NKp05dHeR6jg/mK0Q6AONFFH9tIf29/6s6o4Gi+VTBoZ2sncpAN4jxphVe3ALzvJfYerLRbNnAVqR82Z7h0M3j870gDVDjgfnYk/PvasmKglrHMmzWOZ1xa5mJa9uMxQ6UPJQt94cuBV3bdlw3ubVVYS0jIqdTso3wTbwvrTyfTROaGVoNcFyU0zO0z0Pq2UQ/18xdn36yLXfx1l5hZDpYZfA2Ot88zA77NQA7Ymu/v++nnsfb/u7b/8SISgFfdh80iqkYs4CaAhDCWin7g+0uE80XdT93BQcPldRLwHTHmysPtMIv2JL8JQXnbj6y9vyvZsAnsfh0ZdUESgE/PsyPM/JPputI6K+FQud5CBF0t6mOi9xNnYTjm6tNLyVwyjN5sy3YcA3lZuXRHRVWYcBnEHGKsRVLQeifJ/BKAvGuzFW0YS26dldVcGqg3y5LFUbGLGOgJ4SeVQLmRpoYLyz9Kf9in7N4ASDTrt6V3/DTRUtnzTM79o89fMvM64BUjH2qlUZQ57XX96p7rkYfl4x8D5ygr1K0qpn6d87iNmPKeglSBmewb5JlxlorU/J9PXbw/USuWehqDvhvNvgrlbzVsZRh1a05d8JtVFAFy2yNpwpr3/smyTOwNqqCrvpmzvU8TufgYeClWweVEmsug4iLaMJ/qv6el050AF7RzqtOSNTV6SowXaCMYGD7wUwCIA96hC+Q2W9UEDTb07kjgwbU6luwOGoPIonf0xf9li1ysssQkxeFRwiS7IfPlD3hx3/77wDzb0+y46N1GhAAAAAElFTkSuQmCC);
                            background-repeat: no-repeat;
                            background-size: 60% 60%;
                            background-position: center;
                            border-radius: 50%;
                        }
                    span {
                        margin-right: 10px;
                    }
                }
            }
            .title {
                font-weight: 600;
                font-size: 16px;
                color: #333333;
                .van-field__label {
                    width: auto;
                }
            }
            .van-field__label {
                color: #333333;
            }
            .call-icon {
                display: inline-block;
                width: 24px;
                height: 24px;
                background-image: url('../../../../assets/refund/icon_ts_dh@2x.png');
            }
        }
    }
</style>
